import * as types from './mutation-types'

export default {
  [types.SET_FILTERS] (state,  { key, filters }) {
    state.filters[key] = filters
  },
}
